// extracted by mini-css-extract-plugin
export var actSummary = "act-summary-module--actSummary--fa1df";